import { Address } from '../utils/types'
import React, { FC, useContext, useEffect, useState } from 'react'
import { Web3Context } from './web3'
import Web3 from 'web3'
import { lookIfConnected } from '../components/connection/provider'

export interface ReloadInterface {
  appChainID: number
  account: Address
  provider: any
  web3: Web3 | undefined
}

interface ReloadState {
  nonce: number | undefined
  connected: boolean
  account: Address | undefined
}

export const ReloadContext = React.createContext<ReloadState>({
  connected: false,
  nonce: undefined,
  account: undefined,
})

/**
 * Putting a delay of 100ms if another event is modified, to avoid double 'reload' event
 */
const initialDelay = 1000
const shortDelay = 100
let delay = initialDelay

export const ReloadProvider: FC = ({ children }) => {
  const [delaying, setDelaying] = useState<boolean>(false)
  const [nonce, setNonce] = useState<number | undefined>(undefined)
  const [connected, setConnected] = useState(false)

  const { appChainID, account, provider, web3 } = useContext(
    Web3Context
  ) as ReloadInterface

  useEffect(() => {
    lookIfConnected().then(connected => {
      if (connected) {
        delay = shortDelay
      }
      if (!delaying) {
        setDelaying(true)
        setTimeout(() => {
          setDelaying(false)
          if (nonce === undefined) {
            setNonce(1)
          } else {
            setNonce(nonce + 1)
          }
        }, delay)
      } // else Skipping reload update

      if (account && connected) {
        setConnected(true)
      }
    })
  }, [web3, appChainID, account, provider])

  const value: ReloadState = {
    nonce,
    connected,
    account,
  }

  return (
    <ReloadContext.Provider value={value}>{children}</ReloadContext.Provider>
  )
}

export const useReloader = () => React.useContext(ReloadContext)
